import React from 'react';
import TextInputView from './common/TextInputView';
import ButtonInputView from './common/ButtonInputView';
import SelectInputView from './common/SelectInputView';
import { useIntl } from 'react-intl';
import DateInputView from './common/DateInputView';
import FileInputView from './common/FileInputView';
import { useSelector } from 'react-redux';

const RequiredSection = ({ userInfo, recruitInfo, onChangeUserInfo, onChangeRecruitInfo }) => {
  const authUser = useSelector(store => store.authUser);
  const { formatMessage } = useIntl();
  const { recruitment: config } = useSelector(store => store.config);
  if (!userInfo || !recruitInfo) return <></>;
  const { companyName, businessOwner, email, imageBusinessRegistration } = userInfo;
  const { typeOfWorks, constructionSpaceTypes, constructionAreas, dateEstablishment, numOfEmployee, constructionExperience, businessType } = recruitInfo;
  return (
    <div>
      <TextInputView
        title={formatMessage({ id: 'recruitment.companyName' })}
        required
        placeholder={formatMessage({ id: 'recruitment.companyName' })}
        name="companyName"
        value={companyName}
        onChange={onChangeUserInfo}
      />
      <TextInputView
        title={formatMessage({ id: 'common.businessOwner' })}
        required
        placeholder={formatMessage({ id: 'common.businessOwner' })}
        name="businessOwner"
        value={businessOwner}
        onChange={onChangeUserInfo}
      />
      <TextInputView title={formatMessage({ id: 'common.email' })} required placeholder={formatMessage({ id: 'common.email' })} name="email" value={email} onChange={onChangeUserInfo} />
      {authUser?.token && (
        <FileInputView title={formatMessage({ id: 'recruitment.imageBusinessRegistration' })} required name="imageBusinessRegistration" value={imageBusinessRegistration} onChange={onChangeUserInfo} />
      )}
      <ButtonInputView
        title={config?.TYPE_OF_WORK?.label}
        required
        subTitle={formatMessage({ id: 'common.multiSelect.possible' })}
        items={config?.TYPE_OF_WORK?.items}
        name="typeOfWorks"
        value={typeOfWorks}
        onChange={onChangeRecruitInfo}
      />
      <ButtonInputView
        title={config?.CONSTRUCTION_SPACE_TYPE?.label}
        required
        subTitle={formatMessage({ id: 'common.multiSelect.possible' })}
        items={config?.CONSTRUCTION_SPACE_TYPE?.items}
        name="constructionSpaceTypes"
        value={constructionSpaceTypes}
        onChange={onChangeRecruitInfo}
      />
      <ButtonInputView
        title={config?.CONSTRUCTION_AREA?.label}
        required
        subTitle={formatMessage({ id: 'common.multiSelect.possible' })}
        items={config?.CONSTRUCTION_AREA?.items}
        name="constructionAreas"
        value={constructionAreas}
        onChange={onChangeRecruitInfo}
      />
      <DateInputView
        title={formatMessage({ id: 'recruitment.dateEstablishment' })}
        required
        placeholder={formatMessage({ id: 'recruitment.dateEstablishment.placeholder' })}
        name="dateEstablishment"
        value={dateEstablishment}
        onChange={onChangeRecruitInfo}
      />
      <SelectInputView
        title={config?.NUM_OF_EMPLOYEE?.label}
        required
        placeholder={formatMessage({ id: 'recruitment.numOfEmployee.placeholder' })}
        items={config?.NUM_OF_EMPLOYEE?.items}
        name="numOfEmployee"
        value={numOfEmployee}
        onChange={onChangeRecruitInfo}
      />
      <SelectInputView
        title={config?.CONSTRUCTION_EXPERIENCE?.label}
        required
        placeholder={formatMessage({ id: 'recruitment.constructionExperience.placeholder' })}
        items={config?.CONSTRUCTION_EXPERIENCE?.items}
        name="constructionExperience"
        value={constructionExperience}
        onChange={onChangeRecruitInfo}
      />
      <SelectInputView
        title={formatMessage({ id: 'recruitment.businessType' })}
        required
        placeholder={formatMessage({ id: 'recruitment.businessType.placeholder' })}
        items={config?.BUSINESS_TYPE?.items}
        name="businessType"
        value={businessType}
        onChange={onChangeRecruitInfo}
      />
    </div>
  );
};

export default RequiredSection;
